import React from "react";

const BestRate = () => {
  return (
    <div style={{ padding: 0, margin: 0 }}>
      <iframe
        src="https://dbBestRate.livauto.com/reports.php?c913f-aa72k9q2-55d18bd-92ff3a10-7b2c1e"
        style={{
          width: "100%",
          height: "100vh",
          border: "none",
        }}
        title="First Premier Lending Reports"
      ></iframe>
    </div>
  );
};

export default BestRate;
